// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__duqev","col":"styles_col__1hCHs","actions":"styles_actions__1xzSF","conflict":"styles_conflict__3282k"};